// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-width {
   width: 70%;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

.share-group {
   display: inline-block;
   white-space: nowrap;
   overflow: hidden !important;
   text-overflow: ellipsis;
}
input, textarea {
   outline: none;
}

.button-unshare {
   margin-right:auto;
}

.live-search {
   background-color: #fff;
   box-sizing: border-box;
   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);
   margin-top: 32px;
   max-height: 220px;
   overflow: auto;
   z-index: 5;
}

.file-avatar-icon img {
   display: block;
   width: 45px;
   height: 45px;
   object-fit: contain;
   border-radius: 50%;
}
.name {
   font-size: 14px;
}
.desc {
   color: #999;
   font-size: 12px;
}
.name,.desc {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.fx-for-ie {
   flex: 1 0 auto;
   min-width: 1px;
   min-height: auto;
   line-height: 1.4;
}
.sharelist {
   list-style: none;
   margin: 9px 0 0;
   padding: 0;
   margin-bottom: 10px;
   max-height: 200px;
   max-width: 500px;
}
.file-filename {
   padding: 6px 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/share/share.component.css"],"names":[],"mappings":"AAAA;GACG,UAAU;AACb;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,qBAAqB;GACrB,mBAAmB;GACnB,2BAA2B;GAC3B,uBAAuB;AAC1B;AACA;GACG,aAAa;AAChB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,2CAA2C;GAC3C,gBAAgB;GAChB,iBAAiB;GACjB,cAAc;GACd,UAAU;AACb;;AAEA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,kBAAkB;AACrB;AACA;GACG,eAAe;AAClB;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,cAAc;GACd,cAAc;GACd,gBAAgB;GAChB,gBAAgB;AACnB;AACA;GACG,gBAAgB;GAChB,eAAe;GACf,UAAU;GACV,mBAAmB;GACnB,iBAAiB;GACjB,gBAAgB;AACnB;AACA;GACG,cAAc;AACjB","sourcesContent":[".txt-width {\n   width: 70%;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n.share-group {\n   display: inline-block;\n   white-space: nowrap;\n   overflow: hidden !important;\n   text-overflow: ellipsis;\n}\ninput, textarea {\n   outline: none;\n}\n\n.button-unshare {\n   margin-right:auto;\n}\n\n.live-search {\n   background-color: #fff;\n   box-sizing: border-box;\n   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);\n   margin-top: 32px;\n   max-height: 220px;\n   overflow: auto;\n   z-index: 5;\n}\n\n.file-avatar-icon img {\n   display: block;\n   width: 45px;\n   height: 45px;\n   object-fit: contain;\n   border-radius: 50%;\n}\n.name {\n   font-size: 14px;\n}\n.desc {\n   color: #999;\n   font-size: 12px;\n}\n.name,.desc {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.fx-for-ie {\n   flex: 1 0 auto;\n   min-width: 1px;\n   min-height: auto;\n   line-height: 1.4;\n}\n.sharelist {\n   list-style: none;\n   margin: 9px 0 0;\n   padding: 0;\n   margin-bottom: 10px;\n   max-height: 200px;\n   max-width: 500px;\n}\n.file-filename {\n   padding: 6px 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
